module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"products":{"action":"Fonds finden","empty_state":"Fügen Sie Fonds, die Sie interessant finden Ihrer Watchlist hinzu, um sie dort im Blick zu behalten. Sie werden dann über wichtige Updates informiert.","title":"Watchlist"}}}}}}}')
  delete Component.options._Ctor
}
